var utils = require('./utils');

var header_search = ( function( $ ) {

	var $header;
	var $header_search;
	var $open_button;
	var $close_button;

	var _init = function() {
		$header        = $( 'header#header' );
		$header_search = $( '#header-search' );
		$open_button   = $( '#header-search-open' );
		$close_button  = $( '#header-search-close' );

		$open_button.on( 'click', _toggle_header_search );
		$close_button.on( 'click', _toggle_header_search );
	};

	var _toggle_header_search = function( e ) {
		e.preventDefault();

		$header.toggleClass( 'search-open' );
		$header_search.slideToggle();
	};

	if ( utils.viewport_size().width >= 992 ) {
		$( document ).ready( _init );
	}

} )( jQuery );

module.exports = header_search;